<template>
  <v-layout row wrap>
    <VueGallery :images="$store.getters.bigImages()" :index="index" @close="index = null"></VueGallery>
    <v-flex v-for="(image, i) in $store.getters.smallImages()" :key="i" xs4 sm3 md2 lg2 xl1>
      <v-hover>
        <v-card
          flat
          tile
          class="d-flex"
          slot-scope="{ hover }"
          @click="index = i"
          :class="`elevation-${hover ? 12 : 2}`"
        >
          <v-img :src="image" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-card>
      </v-hover>
    </v-flex>
    <v-flex xs12>
      <p>
        <small>Clique nas imagens para ampliar.</small>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  data: () => ({
    index: null
  }),
  methods: {
    abreFoto: () => {
      alert("Em desenvolvimento...");
    }
  },
  components: {
    VueGallery
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  cursor: pointer;
}

p {
  text-align: center;
}
</style>
